/**
 * English texts
 */

import commonPage from '../routes/app/intl/en'

export default {
  ...commonPage,
}



// WEBPACK FOOTER //
// ./intl/en.js